'use client'

import React from 'react'

import { statusConfigs, statusLabels } from '../StatusField/constants'
import { StatusIcon } from '../StatusField/StatusIcon'
import './styles.scss'

const StatusCell = ({ cellData }: { cellData: unknown }) => {
  const status = cellData as string

  if (!status) {
    return <span>—</span>
  }

  const config = statusConfigs[status] || {
    color: '#6b7280',
    shape: 'circle' as const,
    filled: true,
  }

  return (
    <div className="status-cell">
      <StatusIcon shape={config.shape} color={config.color} filled={config.filled} size={12} />
      <span className="status-label">{statusLabels[status] || status}</span>
    </div>
  )
}

export default StatusCell
